import { isCatalogueDisplayMode } from "@constants";
import { Dialog, DialogActions, DialogTitle } from "@mui/material";

import React from "react";

import {
    getAlertActionButtonImageSrc,
    getNoActionButtonImageSrc,
    getYesActionButtonImageSrc,
} from "@helpers/general";

import "../../index.css";
import SalesModesChangeConfirmationDialogBody from "../SalesModesChangeConfirmationDialogBody";
import useSalesModesChangeConfirmationDialog from "./SalesModesChangeConfirmationHook";

type SalesModesClearConfirmationDialogType = {
    onClose: () => void;
    open: boolean;
};

export default function SalesModesClearConfirmationDialog({
    onClose,
    open,
}: SalesModesClearConfirmationDialogType): JSX.Element {
    const {
        t,
        handleModificationSalesMode,
        setIsPatientModelOpen,
        isPrm,
        logoImageSrc,
        isPatientModelOpen,
        actionsButtons,
    } = useSalesModesChangeConfirmationDialog(onClose);
    return (
        <Dialog
            onClose={onClose}
            open={open}
            container={() => document.querySelector(".fullscreen")}
            PaperProps={{
                sx: {
                    display: "flex!important",
                    gap: "50px!important",
                    alignItems: "center!important",
                    flexDirection: "column!important",
                    paddingTop: "0px!important",
                    paddingBottom: "0px!important",
                    color: "black!important",
                    height: "1335px!important",
                    width: "860px!important",
                    maxWidth: "unset!important",
                    maxHeight: "unset",
                    borderTop: `15px solid var(--global-color)!important`,
                    backgroundColor: "#FFFFFF!important",
                    borderRadius: "111px!important",
                    borderLeft: "1px solid #707070!important",
                    borderRight: "1px solid #707070!important",
                    borderBottom: "1px solid #707070!important",
                    top: isPrm ? "15%" : "unset",
                    right: "unset!important",
                    left: "unset!important",

                    zoom: `${isCatalogueDisplayMode() ? "50%" : "100%"}`,
                },
            }}
            style={{ backdropFilter: "blur(5px)" }}
            onClick={(e) => isPatientModelOpen && e.stopPropagation()}
        >
            <DialogTitle style={{ height: isPrm ? "50%" : "" }}>
                <div
                    className="d-flex justify-content-center align-items-center w-100"
                    style={{ height: isPrm ? "60%" : "" }}
                >
                    <img
                        alt="logo"
                        src={
                            isPatientModelOpen
                                ? logoImageSrc
                                : getAlertActionButtonImageSrc(
                                      actionsButtons as ActionsButtonsDesignType
                                  )
                        }
                        style={{
                            height: "188px",
                            width: "188px",
                        }}
                    />
                </div>
            </DialogTitle>
            <div className="d-flex flex-column justify-content-between h-100">
                <SalesModesChangeConfirmationDialogBody
                    setIsPatientModelOpen={setIsPatientModelOpen}
                    isPatientModelOpen={isPatientModelOpen}
                    onClose={onClose}
                />
                <DialogActions>
                    <div
                        style={{ height: "550px", gap: "30px" }}
                        className="centered-items w-100"
                    >
                        {!isPatientModelOpen ? (
                            <>
                                <div
                                    className="column-centered-items h-100 w-50"
                                    style={{ gap: "20px" }}
                                >
                                    <img
                                        alt="No image"
                                        src={getNoActionButtonImageSrc(
                                            actionsButtons as ActionsButtonsDesignType
                                        )}
                                        style={{ height: "50%", width: "70%" }}
                                        onClick={() => {
                                            onClose();
                                        }}
                                    />

                                    <div className="d-flex justify-content-center align-items-center h-25">
                                        <span
                                            style={{
                                                font: "normal normal 600 33px/49px Segoe UI",
                                            }}
                                        >
                                            {t("No")}
                                        </span>
                                    </div>
                                </div>
                                <div
                                    className="column-centered-items h-100 w-50"
                                    style={{ gap: "20px" }}
                                >
                                    <img
                                        alt="Yes image"
                                        src={getYesActionButtonImageSrc(
                                            actionsButtons as ActionsButtonsDesignType
                                        )}
                                        style={{ height: "50%", width: "70%" }}
                                        onClick={() => {
                                            handleModificationSalesMode();
                                        }}
                                    />

                                    <div className="d-flex justify-content-center align-items-center h-25">
                                        <span
                                            style={{
                                                font: "normal normal 600 33px/49px Segoe UI",
                                            }}
                                        >
                                            {t("Yes")}
                                        </span>
                                    </div>
                                </div>
                            </>
                        ) : null}
                    </div>
                </DialogActions>
            </div>
        </Dialog>
    );
}
